<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="'Job Issue'"
      [canGoBack]="true"
      [customBack]="'get-help'" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper [class]="isRightSideContent ? 'right-side-scroll-enabled' : ''">


    @if (loaded) {
      <tidy-row [align]="'center'">
        <tidy-text
          [body]="'Which job did you have an issue with?'" />
      </tidy-row>
      <tidy-card>
        @for (job of pastJobsResponse | slice:0:showLimiter; track job) {
          <tidy-card-button (action)="next(job)">
            <tidy-row>
              <tidy-text
                [body]="job?.service" />
              <tidy-text
                [body]="(' on ' | translate) + (job?.start_datetime_local | parseDateTime: 'ddd MMM d') + ' ' + (job?.start_datetime_local | parseDateTime: 'h:mma')" />
              <br>
                <tidy-text
                  [helper]="job?.display_address" />
              </tidy-row>
            </tidy-card-button>
          }
          <tidy-card-button (action)="next()">
            <tidy-row>
              <tidy-text
                [body]="'Not Listed'" />
            </tidy-row>
          </tidy-card-button>
          @if (pastJobsResponse.length > 10) {
            <tidy-card-button (action)="showLimit()">
              <tidy-row>
                @if (showLimiter == 10) {
                  <tidy-text
                    [body]="'Show more jobs'" />
                }
                @if (showLimiter !== 10) {
                  <tidy-text
                    [body]="'Show less jobs'" />
                }
              </tidy-row>
            </tidy-card-button>
          }
        </tidy-card>
      }

    </tidy-wrapper>
  </ng-template>

  @if (!isRightSideContent) {
    <app-scroll-wrapper [templateContent]="content" />
  }

  @if (isRightSideContent) {
    <ion-content class="ion-content-right-column">
      <ng-container *ngTemplateOutlet="content" />
    </ion-content>
  }
